// // ChatBox.js
// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import socket from "../utils/socket";
// import { jwtDecode } from "jwt-decode";
// const ChatBox = ({ groupId,chatTitle, onClose }) => {
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState("");
//   const [isTyping, setIsTyping] = useState(false);
//   const [typingUser, setTypingUser] = useState("");
//   const [mentionList, setMentionList] = useState([]);
//   const [mentionDropdown, setMentionDropdown] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   // const [mentionQuery, setMentionQuery] = useState("");

  
  
//   const REACT_APP_SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_BASE_URL || 'http://localhost:9001';

//   console.log("REACT_APP_SOCKET_BASE_URL-->",REACT_APP_SOCKET_BASE_URL)
//   console.log("onClose====>", onClose, groupId);

//   // const effectRan = useRef(false);

//   const messagesEndRef = useRef(null);
//   const token = localStorage.getItem('token');
//   const storedUser = jwtDecode(token);
//   console.log("Decoded Token:", storedUser);
//   const currentUser = {
//     userId: storedUser?.userId,
//     type: storedUser?.roles,
//     name: storedUser?.userName,
//     buyerId: storedUser?.buyerId,
//     receiverIds: storedUser?.associated,
//   };

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   };

//   useEffect(() => {
//     // if (effectRan.current) return;
//     //  effectRan.current = true;

//     // Your side-effect logic here
//     console.log('Effect is running',socket);
//     if (!socket.connected) socket.connect();
//     socket.emit("joinRoom", { groupId });
//     const fetchMessages = async () => {
//         try {
//           const res = await axios.post(
//             `${REACT_APP_SOCKET_BASE_URL}/socket/api/getMessagesByGrouoId`,
//             { groupId: groupId },
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
//               },
//             }
//           );
//           if (Array.isArray(res.data)) {
//             setMessages(res.data);
//           } else if (res.data && Array.isArray(res.data.messages)) {
//             // In case API is sending { messages: [...] }
//             setMessages(res.data.messages);
//           } else {
//             setMessages([]); // fallback to empty array
//           }
//           scrollToBottom();
//         } catch (error) {
//           console.error("Error fetching messages:", error.message);
//         }
//       };
      
//     fetchMessages();
//     const fetchMentionUser = async () => {
//       try {
//         const res = await axios.post(
//           `${REACT_APP_SOCKET_BASE_URL}/socket/api/fetchMentionUser`,
//            {
//               "senderId":currentUser.userId
//            },
//            {
//               headers: {
//                 Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
//               }
//           }
//         );
//         setMentionList(res.data);
//       } catch (error) {
//         console.error("Error fetching mentionList:", error.message);
//       }
//     };
//     fetchMentionUser();

//     const handleNewMessage = (msg) => {
//       console.log("msg.groupId === groupId",msg.groupId, groupId)
//       if (msg.groupId === groupId) {
//         fetchMessages();
//       }
//     };

//     const handleTyping = ({ userName, groupId }) => {
//       if (groupId === groupId && userName !== currentUser.name) {
//         console.log("CURRENT userName typing....?", userName);
//         setTypingUser(userName);
//         setIsTyping(true);
//         setTimeout(() => setIsTyping(false), 3000);
//       }
//     };

//     socket.on("newMessage", handleNewMessage);
//     socket.on("typing", handleTyping);

//     socket.on("connect_error", (err) => console.error("Socket error:", err)); // ADD THIS FOR DEBUGGING

//     return () => {
//       socket.emit("leaveRoom", groupId);
//       socket.off("newMessage", handleNewMessage);
//       socket.off("typing", handleTyping);
//     };
//   }, [groupId, currentUser.userId, currentUser.name,REACT_APP_SOCKET_BASE_URL]);

//   useEffect(() => {
//     const mentionCounts = {};
  
//     messages.forEach((msg) => {
//       const mentioned = msg.message.match(/@(\w+)/g);
//       if (mentioned) {
//         mentioned.forEach((tag) => {
//           const name = tag.slice(1);
//           mentionCounts[name] = (mentionCounts[name] || 0) + 1;
//         });
//       }
//     });
  
//     console.log("Mention counts:", mentionCounts);
//   }, [messages]);
  
//   const handleInputChange = (e) => {
//     const value = e.target.value;
//     setInput(value);
//     socket.emit("typing", { userName: currentUser.name, groupId: groupId });

//     const mentionMatch = value.match(/@(\w*)$/);
//     if (mentionMatch) {
//       const query = mentionMatch[1]?.toLowerCase();
//       const filtered = mentionList?.filter((u) =>
//         u.name?.toLowerCase().startsWith(query)
//       );
//       setMentionDropdown(filtered);
//       // setMentionQuery(query);
//       setShowDropdown(true);
//     } else {
//       setShowDropdown(false);
//     }
//   };

//   const handleSend = () => {
//     if (!input.trim()) return;

//     const newMsg = {
//       groupId: groupId,
//       senderId: currentUser.userId,
//       senderType: currentUser.type,
//       senderName: currentUser.name,
//       receiverIds: currentUser.receiverIds,
//       message: input,
//       timestamp: new Date().toISOString(),
//     };

//     console.log("newMsg==========================> ",newMsg);

//     // if (currentUser.type === "supplier")
//     //   newMsg.receiverId = currentUser.buyerId[0];
//     // if (currentUser.type === "buyer")
//     //   newMsg.receiverId = currentUser.receiverIds[0].userId;


//     socket.emit("sendMessage", newMsg);
//     setMessages((prev) => [...prev, newMsg]);
//     setInput("");
//     scrollToBottom();
//   };

//   const handleMentionSelect = (name) => {
//     const newText = input.replace(/@(\w*)$/, `@${name} `);
//     setInput(newText);
//     setShowDropdown(false);
//   };
//   const highlightIfMentioned = (message) => {
//     return message.includes(`@${currentUser.name}`);
//   };
  
//   const getAvatar = (role) => {
//     return role === "buyer"
//       ? "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
//       : "https://cdn-icons-png.flaticon.com/512/1995/1995574.png";
//   };

//   const formatTime = (timestamp) => {
//     const date = new Date(timestamp);
//     let hours = date.getHours();
//     const minutes = date.getMinutes();
//     const ampm = hours >= 12 ? "PM" : "AM";
//     hours = hours % 12 || 12; // convert to 12-hour format
//     return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
//   };
//   return (
//     <>
//     <div style={styles.chatPanel}>
//       <div style={styles.header}>
//         <span>📝 Chat - {chatTitle} #{groupId}</span>
//         <button onClick={onClose} style={styles.closeButton}>
//           ×
//         </button>
//       </div>

//       <div style={styles.messages}>
//       {Array.isArray(messages) && messages.map((msg, idx)  => {
//           const isSender = msg.senderId === currentUser.userId;
//           return (
//             <div
//               key={idx}
//               style={{
//                 ...styles.messageRow,
//                 justifyContent: isSender ? "flex-end" : "flex-start",
//               }}
//             >
//               {!isSender && (
//                 <img
//                   src={getAvatar(msg.senderType)}
//                   alt="avatar"
//                   style={styles.avatar}
//                 />
//               )}
//               <div
//                 style={{
//                   ...styles.bubble,
//                   // background: isSender ? "#d9fdd3" : "#fff",
//                   background: highlightIfMentioned(msg.message)? '#fff8b3': isSender? '#d9fdd3': '#fff',

//                   alignItems: isSender ? "flex-end" : "flex-start",
//                 }}
//               >
//                 <div style={styles.senderName}>
//                   {isSender ? "You" : msg.senderName}
//                 </div>
//                 {/* <div>{msg.message}</div> */}
//                 <div
//                   dangerouslySetInnerHTML={{
//                     __html: msg.message.replace(
//                       /@(\w+)/g,
//                       '<span style="color: #0b93f6; font-weight: bold;">@$1</span>'
//                     ),
//                   }}
//                 />

//                 <div style={styles.timestamp}>{formatTime(msg.timestamp)}</div>
//               </div>
//               {isSender && (
//                 <img
//                   src={getAvatar(msg.senderType)}
//                   alt="avatar"
//                   style={styles.avatar}
//                 />
//               )}
//             </div>
//           );
//         })}
//         {isTyping && <div style={styles.typing}>{typingUser} is typing...</div>}
//         <div ref={messagesEndRef} />
//       </div>

//       <div style={styles.inputWrapper}>
//         <input
//           type="text"
//           value={input}
//           placeholder="Type a message"
//           onChange={handleInputChange}
//           onKeyDown={(e) => e.key === "Enter" && handleSend()}
//           style={styles.input}
//         />
//         {showDropdown && mentionDropdown.length > 0 && (
//           <div style={styles.mentionDropdown}>
//             {mentionDropdown.map((user) => (
//               <div
//                 key={user.userId}
//                 onClick={() => handleMentionSelect(user.name)}
//                 style={styles.mentionItem}
//               >
//                 @{user.name}
//               </div>
//             ))}
//           </div>
//         )}

//         <button onClick={handleSend} style={styles.sendButton}>
//           Send
//         </button>
//       </div>
      
//     </div>
//     </>
    
//   );
// };

// const styles = {

    
//   chatPanel: {
//     position: "fixed",
//     right: 400,
//     top: 70,
//     width: "400px",
//     // height: '90vh',
//     height: "calc(100vh - 70px)", // ✅ covers exactly the remaining space
//     backgroundColor: "#f0f0f0",
//     display: "flex",
//     flexDirection: "column",
//     boxShadow: "-2px 0 10px rgba(0,0,0,0.1)",
//     zIndex: 9999,
//     borderLeft: "1px solid #ccc",
//     transform: "translateX(100%)",
//     transition: "transform 0.3s ease-in-out"
//   },
//   header: {
//     background: "#ededed",
//     padding: "10px 15px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     fontWeight: "bold",
//     borderBottom: "1px solid #ccc",
//   },
//   closeButton: {
//     background: "transparent",
//     border: "none",
//     fontSize: "18px",
//     cursor: "pointer",
//   },
//   messages: {
//     flex: 1,
//     overflowY: "auto",
//     padding: "10px",
//     backgroundColor: "#e5ddd5",
//   },
//   messageRow: {
//     display: "flex",
//     marginBottom: "10px",
//   },
//   bubble: {
//     padding: "10px",
//     borderRadius: "10px",
//     maxWidth: "70%",
//     boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
//     display: "flex",
//     flexDirection: "column",
//   },
//   senderName: {
//     fontSize: "11px",
//     fontWeight: "bold",
//     color: "#555",
//     marginBottom: "4px",
//   },
//   timestamp: {
//     fontSize: "10px",
//     color: "#888",
//     textAlign: "right",
//     marginTop: "5px",
//   },
//   avatar: {
//     width: "32px",
//     height: "32px",
//     borderRadius: "50%",
//     margin: "0 8px",
//     alignSelf: "flex-end",
//   },
//   typing: {
//     fontStyle: "italic",
//     fontSize: "13px",
//     color: "#555",
//     marginLeft: "10px",
//   },
//   inputWrapper: {
//     display: "flex",
//     padding: "10px",
//     background: "#fff",
//     borderTop: "1px solid #ccc",
//   },
//   input: {
//     flex: 1,
//     padding: "10px",
//     fontSize: "14px",
//     borderRadius: "20px",
//     border: "1px solid #ccc",
//     marginRight: "10px",
//   },
//   sendButton: {
//     backgroundColor: "#4CAF50",
//     color: "#fff",
//     padding: "10px 15px",
//     border: "none",
//     borderRadius: "20px",
//     cursor: "pointer",
//   },

//   mentionDropdown: {
//     position: 'absolute',
//     bottom: '60px',
//     background: '#fff',
//     border: '1px solid #ccc',
//     width: '80%',
//     marginLeft: '10px',
//     borderRadius: '5px',
//     boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
//     zIndex: 10000,
//   },
//   mentionItem: {
//     padding: '8px 10px',
//     cursor: 'pointer',
//     borderBottom: '1px solid #eee',
//   },
// };

// export default ChatBox;




import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import socket from "../utils/socket";
import { jwtDecode } from "jwt-decode";
import { FiSend, FiPaperclip } from "react-icons/fi"; // ✅ Icons

const ChatBox = ({ groupId, chatTitle, onClose, visible }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [typingUser, setTypingUser] = useState("");
  const [mentionList, setMentionList] = useState([]);
  const [mentionDropdown, setMentionDropdown] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [attachment, setAttachment] = useState(null); // ✅ For file

  const messagesEndRef = useRef(null);
  const token = localStorage.getItem("token");
  const storedUser = jwtDecode(token);

  const currentUser = {
    userId: storedUser?.userId,
    type: storedUser?.roles,
    name: storedUser?.userName,
    buyerId: storedUser?.buyerId,
    receiverIds: storedUser?.associated,
  };

  const REACT_APP_SOCKET_BASE_URL =
    process.env.REACT_APP_SOCKET_BASE_URL || "http://localhost:9001";

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (!socket.connected) socket.connect();
    socket.emit("joinRoom", { groupId });

    const fetchMessages = async () => {
      try {
        const res = await axios.post(
          `${REACT_APP_SOCKET_BASE_URL}/socket/api/getMessagesBygroupId`,
          { groupId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const msgs = Array.isArray(res.data) ? res.data : res.data?.messages || [];
        setMessages(msgs);
        scrollToBottom();
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    const fetchMentionUser = async () => {
      try {
        const res = await axios.post(
          `${REACT_APP_SOCKET_BASE_URL}/socket/api/fetchMentionUser`,
          { senderId: currentUser.userId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setMentionList(res.data);
      } catch (error) {
        console.error("Mention user fetch error:", error.message);
      }
    };

    fetchMessages();
    fetchMentionUser();

    const handleNewMessage = (msg) => {
      if (msg.groupId === groupId) fetchMessages();
    };

    const handleTyping = ({ userName, chatId }) => {
      if (groupId === chatId && userName !== currentUser.name) {
        setTypingUser(userName);
        setIsTyping(true);
        setTimeout(() => setIsTyping(false), 3000);
      }
    };

    socket.on("newMessage", handleNewMessage);
    socket.on("typing", handleTyping);

    return () => {
      socket.emit("leaveRoom", groupId);
      socket.off("newMessage", handleNewMessage);
      socket.off("typing", handleTyping);
    };
  }, [REACT_APP_SOCKET_BASE_URL, currentUser.name, currentUser.userId, groupId, token]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInput(value);
    socket.emit("typing", { userName: currentUser.name, groupId });

    const mentionMatch = value.match(/@(\w*)$/);
    if (mentionMatch) {
      const query = mentionMatch[1]?.toLowerCase();
      const filtered = mentionList.filter((u) =>
        u.name.toLowerCase().startsWith(query)
      );
      setMentionDropdown(filtered);
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleMentionSelect = (name) => {
    const newText = input.replace(/@(\w*)$/, `@${name} `);
    setInput(newText);
    setShowDropdown(false);
  };

  const handleSend = () => {
    if (!input.trim() && !attachment) return;

    const newMsg = {
      groupId,
      chatId: groupId,
      senderId: currentUser.userId,
      senderType: currentUser.type,
      senderName: currentUser.name,
      receiverIds: currentUser.receiverIds,
      message: input,
      attachment: attachment ? attachment.name : null, // Stub, handle upload if needed
      timestamp: new Date().toISOString(),
    };

    socket.emit("sendMessage", newMsg);
    setMessages((prev) => [...prev, newMsg]);
    setInput("");
    setAttachment(null);
    scrollToBottom();
  };

  const handleAttachment = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAttachment(file);
    }
  };

  const highlightIfMentioned = (msg) => msg.includes(`@${currentUser.name}`);

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    let h = date.getHours();
    const m = date.getMinutes().toString().padStart(2, "0");
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${m} ${ampm}`;
  };

  return (
    <div
      style={{
        ...styles.wrapper,
        transform: visible ? "translateX(0%)" : "translateX(100%)",
      }}
    >
      <div style={styles.header}>
        <span>💬 Chat: {chatTitle} #{groupId}</span>
        <button onClick={onClose} style={styles.closeBtn}>×</button>
      </div>

      <div style={styles.body}>
        {messages.map((msg, i) => {
          const isSender = msg.senderId === currentUser.userId;
          const highlight = highlightIfMentioned(msg.message);
          return (
            <div key={i} style={{ ...styles.messageRow, justifyContent: isSender ? "flex-end" : "flex-start" }}>
              <div style={{
                ...styles.messageBubble,
                backgroundColor: highlight ? "#fff8b3" : isSender ? "#d9fdd3" : "#f0f0f0",
              }}>
                <div style={styles.sender}>{isSender ? "You" : msg.senderName}</div>
                <div dangerouslySetInnerHTML={{
                  __html: msg.message.replace(
                    /@(\w+)/g,
                    '<span style="color:#0b93f6;font-weight:bold;">@$1</span>'
                  )
                }} />
                {msg.attachment && (
                  <div style={{ marginTop: 6 }}>
                    <span style={{ color: "#0077cc" }}>📎 {msg.attachment}</span>
                  </div>
                )}
                <div style={styles.timestamp}>{formatTime(msg.timestamp)}</div>
              </div>
            </div>
          );
        })}

        {isTyping && (
          <div style={styles.typing}>{typingUser} is typing...</div>
        )}
        <div ref={messagesEndRef} />
      </div>

      <div style={styles.inputArea}>
        <div style={styles.inputWrapper}>
          <input
            type="text"
            placeholder="Type your message..."
            value={input}
            onChange={handleInputChange}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
            style={styles.input}
          />
          <label htmlFor="file-upload" style={styles.attachmentIcon}>
            <FiPaperclip size={18} />
            <input id="file-upload" type="file" style={{ display: "none" }} onChange={handleAttachment} />
          </label>
          <button onClick={handleSend} style={styles.sendBtn}>
            <FiSend size={18} />
          </button>
        </div>
        {showDropdown && (
          <div style={styles.dropdown}>
            {mentionDropdown.map((u) => (
              <div
                key={u.userId}
                onClick={() => handleMentionSelect(u.name)}
                style={styles.dropdownItem}
              >
                @{u.name}
              </div>
            ))}
          </div>
        )}
        {attachment && (
          <div style={styles.attachmentPreview}>
            📎 {attachment.name}
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    position: "fixed",
    right: 0,
    bottom: 20,
    width: 380,
    height: 600,
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    display: "flex",
    flexDirection: "column",
    zIndex: 9999,
    transform: "translateX(100%)",
    transition: "transform 0.5s ease-in-out",
  },
  header: {
    background: "#ededed",
    padding: "10px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
    borderBottom: "1px solid #ccc",
  },
  closeBtn: {
    background: "transparent",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
  },
  body: {
    flex: 1,
    padding: "10px",
    overflowY: "auto",
  },
  messageRow: {
    display: "flex",
    marginBottom: 10,
  },
  messageBubble: {
    maxWidth: "75%",
    padding: "8px 12px",
    borderRadius: "10px",
    lineHeight: 1.4,
    fontSize: "14px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  sender: {
    fontWeight: "bold",
    marginBottom: 2,
  },
  timestamp: {
    fontSize: "10px",
    textAlign: "right",
    marginTop: 4,
    color: "#999",
  },
  typing: {
    fontStyle: "italic",
    fontSize: "12px",
    color: "#555",
    margin: "5px 0",
  },
  inputArea: {
    borderTop: "1px solid #eee",
    padding: "10px",
    position: "relative",
  },
  inputWrapper: {
    display: "flex",
    alignItems: "center",
  },
  input: {
    flex: 1,
    padding: "8px 12px",
    borderRadius: "20px",
    border: "1px solid #ccc",
    outline: "none",
    fontSize: "14px",
  },
  sendBtn: {
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    padding: "8px",
    marginLeft: "6px",
    cursor: "pointer",
  },
  attachmentIcon: {
    marginLeft: "6px",
    cursor: "pointer",
    color: "#555",
  },
  dropdown: {
    position: "absolute",
    bottom: "45px",
    left: "10px",
    right: "10px",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "6px",
    maxHeight: "120px",
    overflowY: "auto",
    zIndex: 2000,
  },
  dropdownItem: {
    padding: "8px 12px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
  },
  attachmentPreview: {
    marginTop: "6px",
    fontSize: "12px",
    color: "#333",
  },
};

export default ChatBox;

